import { Flow_0_0_2, getFullItemOne } from '@flexus/core';
import { map } from 'rxjs/operators';

export const SIL_CALL_LOGS: Flow_0_0_2 = {
	id: 'CallLogs',
	itemType: 'flow',
	name: 'Call Logs',
	excludeForOnlyStates: [169],
	header: {
		title: (store, bf) => {
			return store.select(getFullItemOne).pipe(
				map(itemOne => {
					if (itemOne) {
						return `Call Logs  :  ${itemOne?.loan_information?.mavenclaimnumber}  -  ${itemOne?.applicant?.surname} `;
					} else {
						return 'Call Logs';
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	startNode: 'CallLogs',
	instructions: {
		editRoles: {
			0: ''
		},
		viewRoles: {
			0: ''
		}
	},
	actionPanel: instance => {
		return () => {
			return [{}];
		};
	},
	nodes: {
		CallLogs: {
			component: 'CallLogsComponent',
			navs: [],
			inputs: {
				title: 'Call Logs',
				location: 'context'
			}
		},
		SubmissionSuccess: {
			component: 'FlXSubmissionSuccess'
		}
	},
	bigFormToStoreMapper: {},

	serverCalls: {
		logs: {
			serviceVariable: 'silService',
			functionName: 'getCallLogs',
			// responseSlice: 'payload',
			errorMessage: 'No call logs could be found!'
		}
	}
};
